import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useFetch } from 'src/utils/hooks/useFetch';
import { OtherApi } from 'src/api/base/other';
import { setNotifications } from 'src/store/notifications/slice';

interface IUseNotificationsSetupReturn {
  error: any;
  isLoading: boolean;
}

export function useNotificationSetup(): IUseNotificationsSetupReturn {
  const dispatch = useDispatch();

  const [{ response, isLoading, error }, doFetch] = useFetch(
    OtherApi.getNotification,
  );

  useEffect(() => {
    doFetch();
  }, [doFetch]);

  useEffect(() => {
    if (response) {
      dispatch(setNotifications(response.data.data));
    }
  }, [response, dispatch]);

  return { isLoading, error };
}
